import { useState, useEffect } from 'react'

import { usePopper } from 'react-popper'
import classNames from 'classnames'
import Fade from 'components/misc/Fade'
import popperStyles from 'components/misc/styles/Tooltip.css'

const TooltipFlash = ({
  className,
  tooltipClassName,
  onClick,
  children,
  content,
  flash,
  flashTime = 1000,
  ...rest
}) => {
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const [arrowElement, setArrowElement] = useState(null)
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!flash) {
      return () => null
    }

    setShow(true)
    const timeout = setTimeout(() => setShow(false), flashTime)

    return () => window.clearTimeout(timeout)
  }, [flash])

  const { styles: popperStyle, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: arrowElement
        }
      },
      {
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }
    ]
  })

  return (
    <>
      <div className={className} ref={setReferenceElement} onClick={onClick} {...rest}>
        {children}
      </div>
      <Fade show={show}>
        <div
          className={classNames(popperStyles.popperBase, popperStyles.popper, tooltipClassName)}
          ref={setPopperElement}
          style={popperStyle.popper}
          {...attributes.popper}
        >
          {content}
          <div
            className={classNames(popperStyles.arrow, popperStyles.arrowBlack)}
            ref={setArrowElement}
            style={popperStyle.arrow}
          />
        </div>
      </Fade>
    </>
  )
}

export default TooltipFlash
